module.exports = "https://img1.zhuanstatic.com/platform/zz-universal-pages/static/img/frontgoods.fd3a198f.jpg";